module.exports = __webpack_public_path__ + "static/img/success.f141654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/success.png
// module id = Agxa
// module chunks = 2